/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HPLC Method Transfer Calculator (Column Scaling) — Toolverse`)
};

const es_hplc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Transferencia de Métodos HPLC (Escalado de Columna) — Toolverse`)
};

const de_hplc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HPLC-Methodentransfer-Rechner (Säulen-Skalierung) — Toolverse`)
};

const nl_hplc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HPLC-methodetransfercalculator (Kolomschaling) — Toolverse`)
};

const fr_hplc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de transfert de méthode HPLC (adaptation de colonne) — Toolverse`)
};

const it_hplc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore trasferimento metodo HPLC (scalatura colonna) — Toolverse`)
};

const pt_br2_hplc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Transferência de Método de HPLC (Dimensionamento de Coluna) — Toolverse`)
};

const pt_hplc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Transferência de Método de HPLC (Escala de Coluna) — Toolverse`)
};

const ja_hplc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HPLCメソッド移行計算機(カラムスケーリング) — Toolverse`)
};

const zh_hplc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HPLC 方法转移计算器（色谱柱放大） — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_meta_title", locale)
	if (locale === "en") return en_hplc_meta_title(inputs)
	if (locale === "es") return es_hplc_meta_title(inputs)
	if (locale === "de") return de_hplc_meta_title(inputs)
	if (locale === "nl") return nl_hplc_meta_title(inputs)
	if (locale === "fr") return fr_hplc_meta_title(inputs)
	if (locale === "it") return it_hplc_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_meta_title(inputs)
	if (locale === "pt") return pt_hplc_meta_title(inputs)
	if (locale === "ja") return ja_hplc_meta_title(inputs)
	return zh_hplc_meta_title(inputs)
};